<template>
  <div class="findus">
    <div class="map-toolbox">
      <div class="searchbox">
        <input
          placeholder="尋找 銳仕技研經銷門市"
          @focus="show_seatch_list = true"
          v-model="search_keyword"
          type="text"
          class="sb__field"
        />
        <button
          @click="ClearKeyWord"
          class="sb__clear"
          :class="{ active: search_keyword.length != 0 }"
        ></button>

        <ul
          class="sb_list"
          v-show="search_keyword.length != 0 && show_seatch_list"
        >
          <li
            v-for="item in shop_list.filter((shop) => {
              return (
                shop.address.indexOf(search_keyword) != -1 ||
                shop.name.indexOf(search_keyword) != -1
              );
            })"
            :key="item.shop_id"
            @click="ChooseShop(item.shop_id)"
          >
            {{ item.name }}
            <span>{{ item.address }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="shop_detailbox" v-if="search_shop_id != -1">
      <div class="title_box">
        <h3>
          {{
            shop_list.filter((shop) => {
              return shop.shop_id == search_shop_id;
            })[0].name
          }}
        </h3>
        <a
          :href="
            `https://www.google.com/maps/search/?api=1&amp;query=${
              shop_list.filter((shop) => {
                return shop.shop_id == search_shop_id;
              })[0].name
            } ${
              shop_list.filter((shop) => {
                return shop.shop_id == search_shop_id;
              })[0].address
            }`
          "
          class="google_map_btn"
          >立即前往</a
        >
      </div>
      <div class="address_box">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="location-arrow"
          class="svg-inline--fa fa-location-arrow fa-w-16"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
          ></path>
        </svg>
        <p>
          {{
            shop_list.filter((shop) => {
              return shop.shop_id == search_shop_id;
            })[0].address
          }}
        </p>
      </div>
      <div class="phone_box">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="phone-alt"
          class="svg-inline--fa fa-phone-alt fa-w-16"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
          ></path>
        </svg>
        <p>
          {{
            shop_list.filter((shop) => {
              return shop.shop_id == search_shop_id;
            })[0].phone
          }}
        </p>
      </div>
    </div>
    <div id="map" @click="show_seatch_list = false"></div>
  </div>
</template>

<script>
import L from "leaflet";
let openStreetMap = {};
var myIcon = L.icon({
  iconUrl: "/img/findus/map_icon.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

export default {
  name: "Findus",
  data() {
    return {
      shop_list: [],
      search_keyword: "",
      search_shop_id: -1,
      show_seatch_list: false,
    };
  },
  components: {},
  methods: {
    async GetShopList() {
      let result = await this.SendGetData(
        process.env.VUE_APP_BASE_API + "shop/get_shop_list.php"
      );
      if (result != "error") {
        let data = JSON.parse(result.data);
        this.shop_list = data;
        this.$nextTick(() => {
          this.UpdateMap();
          window.prerenderReady = true;
        });
      }
    },
    UpdateMap() {
      let that = this;
      this.shop_list.forEach((shop) => {
        let marker = L.marker([shop.coordinatesX, shop.coordinatesY], {
          riseOnHover: true,
          icon: myIcon,
        }).addTo(openStreetMap);

        marker.on("click", function() {
          that.ChooseShop(shop.shop_id);
        });
      });
    },
    ClearKeyWord() {
      this.search_keyword = "";
      openStreetMap.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          openStreetMap.removeLayer(layer);
        }
      });
      openStreetMap.setView([23.983169, 120.532309], 8);
      this.search_shop_id = -1;
      this.UpdateMap();
    },
    ChooseShop(shop_index) {
      this.search_shop_id = shop_index;
      let choosen_shop = this.shop_list.filter((shop) => {
        return shop.shop_id == shop_index;
      })[0];
      this.show_seatch_list = false;
      this.search_keyword = choosen_shop.name;

      L.marker([choosen_shop.coordinatesX, choosen_shop.coordinatesY], {
        riseOnHover: true,
        icon: myIcon,
      }).addTo(openStreetMap);

      openStreetMap.setView(
        [choosen_shop.coordinatesX, choosen_shop.coordinatesY],
        18
      );
    },
  },
  mounted() {
    openStreetMap = L.map("map", {
      center: [23.983169, 120.532309],
      zoom: 8,
      zoomControl: false,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      maxNativeZoom: 18,
    }).addTo(openStreetMap);
  },
  created() {
    this.GetShopList();
  },

  metaInfo() {
    return {
      title: "經銷據點｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "銳仕技研全台經銷據點，直接搜尋離你最近的銷售據點",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "銳仕技研全台經銷據點，直接搜尋離你最近的銷售據點",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "銳仕技研全台經銷據點，直接搜尋離你最近的銷售據點",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "經銷據點｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "經銷據點｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "經銷據點｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
